import { FC } from "react";

interface TransportCategoryIconSVGProps {
    className?: string;
    selected?: boolean;
}

const TransportCategoryIconSVG: FC<TransportCategoryIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="63"
            height="63"
            viewBox="0 0 63 63"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {props.selected ? (
                <path
                    d="M26.25 5.25H36.75M55.125 21L49.875 26.25M49.875 26.25L45.9375 16.5375C45.5662 15.5435 44.9024 14.6854 44.0336 14.0762C43.1648 13.467 42.1318 13.1354 41.0708 13.125H22.05C20.9803 13.1004 19.9287 13.4033 19.0359 13.993C18.1431 14.5827 17.4518 15.4311 17.0546 16.4246L13.125 26.25M49.875 26.25H13.125M49.875 26.25C52.7745 26.25 55.125 28.6005 55.125 31.5V42C55.125 44.8995 52.7745 47.25 49.875 47.25M13.125 26.25L7.875 21M13.125 26.25C10.2255 26.25 7.875 28.6005 7.875 31.5V42C7.875 44.8995 10.2255 47.25 13.125 47.25M18.375 36.75H18.4013M44.625 36.75H44.6513M49.875 47.25H13.125M49.875 47.25V52.5M13.125 47.25L13.125 52.5"
                    stroke="white"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            ) : (
                <>
                    <path
                        d="M26.25 5.25H36.75M55.125 21L49.875 26.25M49.875 26.25L45.9375 16.5375C45.5662 15.5435 44.9024 14.6854 44.0336 14.0762C43.1648 13.467 42.1318 13.1354 41.0708 13.125H22.05C20.9803 13.1004 19.9287 13.4033 19.0359 13.993C18.1431 14.5827 17.4518 15.4311 17.0546 16.4246L13.125 26.25M49.875 26.25H13.125M49.875 26.25C52.7745 26.25 55.125 28.6005 55.125 31.5V42C55.125 44.8995 52.7745 47.25 49.875 47.25M13.125 26.25L7.875 21M13.125 26.25C10.2255 26.25 7.875 28.6005 7.875 31.5V42C7.875 44.8995 10.2255 47.25 13.125 47.25M18.375 36.75H18.4013M44.625 36.75H44.6513M49.875 47.25H13.125M49.875 47.25V52.5M13.125 47.25L13.125 52.5"
                        stroke="url(#paint0_linear_196_10131)"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_196_10131"
                            x1="7.50575"
                            y1="5.47957"
                            x2="63.2637"
                            y2="49.1069"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="white" />
                            <stop offset="1" stopColor="#4A4A4F" />
                        </linearGradient>
                    </defs>
                </>
            )}
        </svg>
    );
};

export default TransportCategoryIconSVG;
